// shared/data/fetchPublicProfile.js
import axios from '../config/axios';

export async function fetchPublicProfile(token) {
  const res = await axios.get('/me/public-profile', {
    headers: { Authorization: `Bearer ${token}` },
  });

  return res.data;
}
